<template>
    <transition name="fade" mode="out-in">
        <router-view></router-view>
    </transition>
</template>

<script>
    import Vue from 'vue';
    import { Component } from 'vue-property-decorator';
    import {IS_AUTHENTICATED} from '../../store/modules/auth';

    @Component
    export default class Authentication extends Vue {
        name = 'authentication';

        created() {
            if (this.$store.getters[IS_AUTHENTICATED]) {
                var redirect = this.$route.query.redirect;
                if (redirect) {
                    this.$router.replace(redirect);
                } else {
                    this.$router.replace({
                        name: 'home'
                    });
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/auth/Authentication.vue